module.exports = __webpack_public_path__ + "img/trash.95523008.svg";